module.exports = __webpack_public_path__ + "static/media/icon_evaluation.89bbb1ae.svg";